const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "18px",
    height: "18px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface115035021"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.398438 15 L 2.398438 15 L 2.398438 6 L 5.398438 6 Z M 3.902344 4.800781 C 3.070312 4.800781 2.398438 4.128906 2.398438 3.300781 C 2.398438 2.472656 3.070312 1.800781 3.902344 1.800781 C 4.726562 1.800781 5.398438 2.472656 5.398438 3.300781 C 5.398438 4.128906 4.726562 4.800781 3.902344 4.800781 Z M 16.199219 15 L 13.316406 15 L 13.316406 10.621094 C 13.316406 9.574219 13.296875 8.230469 11.816406 8.230469 C 10.316406 8.230469 10.082031 9.371094 10.082031 10.542969 L 10.082031 15 L 7.199219 15 L 7.199219 5.992188 L 9.96875 5.992188 L 9.96875 7.222656 L 10.007812 7.222656 C 10.394531 6.515625 11.335938 5.769531 12.738281 5.769531 C 15.660156 5.769531 16.199219 7.636719 16.199219 10.058594 C 16.199219 10.058594 16.199219 15 16.199219 15 Z M 16.199219 15 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.db8bba6503f62d8f9c0a8ca036eb063b.svg";
export { ForwardRef as ReactComponent };